/**
 * TableContextProvider - контекст провайдер для TableStore
 */

import { Table as TableAntd } from 'antd'
import { createContext, useContext } from 'react'
import { configManager } from '../../Managers/Config'
import { EventManager } from '../../Managers/Event/EventManager'
import { MergeConfigAndPropsTask } from '../../Tasks/Utils/MergeConfigAndPropsTask'
import { TableStore } from './Stores/TableStore'

export const TableContext = createContext<TableStore | null>(null)

/**
 * Створює новий TableStore з заданою конфігурацією
 */
export const createTableContext = (props: any = {}): TableStore => {
    // Отримуємо конфігурацію Table
    const tableConfig = configManager.get('TableConfig', {})
    
    // Об'єднуємо конфігурацію з пропсами через MergeConfigAndPropsTask
    const mergedProps = MergeConfigAndPropsTask({
        tableConfig,
        tableProps: props,
    }) || props
    
    // Встановлюємо шаблон за замовчуванням
    if (!mergedProps.template) {
        mergedProps.template = TableAntd
    }
    
    if( mergedProps.isObservable === undefined ) {
        mergedProps.isObservable = true
    }

    // Створюємо тимчасовий eventManager для виконання onBeforeInit
    const tempEventManager = new EventManager()
    
    // Виконуємо всі onBeforeInit події з переданих пропсів
    if (mergedProps.eventHandlers?.onBeforeInit) {
        Object.entries(mergedProps.eventHandlers.onBeforeInit).forEach(([name, handler]) => {
            tempEventManager.on('onBeforeInit', name, handler as any)
        })
    }

    // Emit onBeforeInit події - передаємо props по ссылці для можливості змін
    tempEventManager.emit('onBeforeInit', { props: mergedProps })
    
    // Створюємо екземпляр TableStore
    const tableContext = new TableStore(mergedProps)
    
    // Виконуємо onAfterInit події з eventManager створеного екземпляра
    tableContext.getEventManager().emit('onAfterInit', { tableContext })
    
    return tableContext
}

/**
 * Хук для отримання TableContext
 */
export const useTableContext = (): TableStore | null => {
    const context = useContext(TableContext)
    return context
}

/**
 * Provider компонент для TableContext
 */
export const TableContextProvider = TableContext.Provider
